import {
  IPhieuNhapKhoResponseBase,
  IRoleResponseBase,
} from '@/core/interfaces/ApiResponses';
import { evaluatePermission } from '@/core/helpers/checkAbility';
import { hasAdminRole } from '@/core/helpers/authorization-utils';
import { PHIEU_NHAP_KHO } from '@/core/constants/permissions';
import store from '@/store';

const usePhieuNhap = () => {
  const goToEditPhieuNhap = ({ id }: IPhieuNhapKhoResponseBase) => ({
    name: 'cap-nhat-phieu-nhap-kho',
    params: { id },
  });

  const canEditByAuthz = (phieuNhapData: IPhieuNhapKhoResponseBase) => {
    const roles = (store.getters.roles as IRoleResponseBase[] | undefined) || [];
    const roleNames = roles.map((role) => role.name);

    // Admin can edit all tickets
    if (hasAdminRole(roleNames)) {
      return true;
    }

    // Non-admin with data:pnk:sua can edit all tickets (no owner check)
    if (evaluatePermission({ value: PHIEU_NHAP_KHO.SUA })) {
      return true;
    }

    // Non-admin without sua: only owner tickets via can_edit
    return phieuNhapData.can_edit === true;
  };

  const editable = (phieuNhapData: IPhieuNhapKhoResponseBase | null) => {
    if (!phieuNhapData) {
      return false;
    }

    const statusAllowsEdit =
      phieuNhapData.is_approved === false && !phieuNhapData.ngay_hoan_thanh;

    if (!statusAllowsEdit) {
      return false;
    }

    return canEditByAuthz(phieuNhapData);
  };

  return {
    editable,
    goToEditPhieuNhap,
  };
};

export default usePhieuNhap;
